import type { AttachmentInput } from "@noverik/contracts";

function readAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => reject(new Error("Não foi possível ler o arquivo."));
    reader.onload = () => {
      const value = String(reader.result ?? "");
      const comma = value.indexOf(",");
      resolve(comma >= 0 ? value.slice(comma + 1) : value);
    };

    reader.readAsDataURL(file);
  });
}

export async function encodeAttachments(files: File[]): Promise<AttachmentInput[]> {
  if (files.length > 10) {
    throw new Error("Envie no máximo 10 arquivos por vez.");
  }

  // Read independent files concurrently instead of serializing FileReader
  // operations. The order in the selected file list remains unchanged.
  return Promise.all(files.map(async (file): Promise<AttachmentInput> => ({
    name: file.name,
    type: file.type || "application/octet-stream",
    size: file.size,
    data: await readAsBase64(file),
  })));
}
